var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFpaLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.367,
    height: 35.555,
    viewBox: "0 0 123.367 35.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61610",
    "data-name": "Group 61610",
    transform: "translate(-611.415 -734.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60790",
    "data-name": "Group 60790",
    transform: "translate(651.952 743.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82098",
    "data-name": "Path 82098",
    d: "M242.985,36.672a3.236,3.236,0,0,1-3.236,3.236H227.026a2.306,2.306,0,0,0-2.307,2.305v2.115h11.793a3.237,3.237,0,0,1,0,6.474h-9.545a2.307,2.307,0,0,0-2.248,2.305v2.487a3.236,3.236,0,0,1-6.472,0V42.213a8.778,8.778,0,0,1,8.779-8.777H239.75a3.236,3.236,0,0,1,3.236,3.236",
    transform: "translate(-218.247 -33.434)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82099",
    "data-name": "Path 82099",
    d: "M242.985,36.672a3.236,3.236,0,0,1-3.236,3.236H227.026a2.306,2.306,0,0,0-2.307,2.305v2.115h11.793a3.237,3.237,0,0,1,0,6.474h-9.545a2.307,2.307,0,0,0-2.248,2.305v2.487a3.236,3.236,0,0,1-6.472,0V42.213a8.778,8.778,0,0,1,8.779-8.777H239.75A3.236,3.236,0,0,1,242.985,36.672Z",
    transform: "translate(-218.247 -33.434)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82096",
    "data-name": "Path 82096",
    d: "M391.515,50.764c-.081,0-.163,0-.244,0h-7.365a2.308,2.308,0,0,0-2.307,2.307v2.511a3.236,3.236,0,0,1-6.472,0V51.16A6.864,6.864,0,0,1,381.99,44.3h9.2a2.253,2.253,0,0,0,2.257-1.909,2.2,2.2,0,0,0-1.9-2.47,2.455,2.455,0,0,0-.285-.019l-13.018.025a3.236,3.236,0,1,1,0-6.472l12.835-.025a8.791,8.791,0,0,1,8.849,8.409,8.678,8.678,0,0,1-8.422,8.929",
    transform: "translate(-346.012 -33.426)",
    fill: "#1b1c27",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82097",
    "data-name": "Path 82097",
    d: "M392,50.764c-.081,0-.163,0-.244,0h-7.365a2.308,2.308,0,0,0-2.307,2.307v2.511a3.236,3.236,0,1,1-6.472,0V51.16a6.864,6.864,0,0,1,6.864-6.864h9.2a2.252,2.252,0,0,0,2.257-1.909,2.2,2.2,0,0,0-1.9-2.47,2.455,2.455,0,0,0-.285-.019H378.958a3.236,3.236,0,0,1,0-6.472h12.611a8.791,8.791,0,0,1,8.849,8.409A8.678,8.678,0,0,1,392,50.764Z",
    transform: "translate(-346.493 -33.426)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82094",
    "data-name": "Path 82094",
    d: "M535.541,54.9a2.308,2.308,0,0,1,2.307-2.307h7.264a2.308,2.308,0,0,1,2.307,2.307v.683a3.236,3.236,0,0,0,6.472,0V43.367a9.942,9.942,0,0,0-9.941-9.941h-4.942a9.941,9.941,0,0,0-9.941,9.941V55.583a3.236,3.236,0,0,0,6.472,0s0-.1,0-.681m11.878-8.779h-11.88V43.367a3.468,3.468,0,0,1,3.469-3.469h4.942a3.47,3.47,0,0,1,3.469,3.469Z",
    transform: "translate(-471.561 -33.426)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82095",
    "data-name": "Path 82095",
    d: "M535.541,54.9a2.308,2.308,0,0,1,2.307-2.307h7.264a2.308,2.308,0,0,1,2.307,2.307v.683a3.236,3.236,0,0,0,6.472,0V43.367a9.942,9.942,0,0,0-9.941-9.941h-4.942a9.941,9.941,0,0,0-9.941,9.941V55.583a3.236,3.236,0,0,0,6.472,0S535.538,55.479,535.541,54.9Zm11.878-8.779h-11.88V43.367a3.468,3.468,0,0,1,3.469-3.469h4.942a3.47,3.47,0,0,1,3.469,3.469Z",
    transform: "translate(-471.561 -33.426)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60784",
    "data-name": "Group 60784",
    transform: "translate(611.415 734.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82080",
    "data-name": "Path 82080",
    d: "M31.878,95.887A3.976,3.976,0,0,1,27.9,99.864H9.657c-.057,0-.114,0-.17,0H9.253a9.242,9.242,0,0,1-9.24-9.029A1.231,1.231,0,0,1,0,90.647V79.793A3.963,3.963,0,0,1,3.963,75.83h.021a3.962,3.962,0,0,1,3.962,3.963V90.475A1.434,1.434,0,0,0,9.38,91.909h2.663v-4.16a3.967,3.967,0,1,1,7.933,0v2.8c0-.024,0-.049,0-.074l0,.074a1.434,1.434,0,0,0,1.431,1.36H27.9a3.978,3.978,0,0,1,3.977,3.978",
    transform: "translate(0.072 -64.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82081",
    "data-name": "Path 82081",
    d: "M161.122,203.284v1.36h0V203.21c0,.024,0,.049,0,.074",
    transform: "translate(-142.524 -177.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82082",
    "data-name": "Path 82082",
    d: "M161.122,203.284v1.36h0V203.21c0,.024,0,.049,0,.074",
    transform: "translate(-142.524 -177.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82083",
    "data-name": "Path 82083",
    d: "M195.112,140a3.978,3.978,0,1,1-3.978,3.978A3.977,3.977,0,0,1,195.112,140",
    transform: "translate(-167.14 -123.21)",
    fill: "#0a8cfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82084",
    "data-name": "Path 82084",
    d: "M103.067,69a3.932,3.932,0,1,1-3.932,3.932A3.932,3.932,0,0,1,103.067,69",
    transform: "translate(-87.06 -60.075)",
    fill: "#23cc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82085",
    "data-name": "Path 82085",
    d: "M11.1,0A3.988,3.988,0,1,1,7.114,3.988,3.988,3.988,0,0,1,11.1,0",
    transform: "translate(-7.114 0)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22136",
    "data-name": "Rectangle 22136",
    width: 29.118,
    height: 32.752,
    transform: "translate(0.072 2.342)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpaLogoLight);
export default __webpack_public_path__ + "static/media/fpa-logo-light.462587227d50661205a808e570bc9493.svg";
export { ForwardRef as ReactComponent };